module.exports = __webpack_public_path__ + "static/media/ic_general_communications_black.dfae26a0.svg";